
import { ScheduleItem } from '@/integrations/supabase/client';

export const regularSessions: ScheduleItem[] = [
  {
    id: "implementing-responsible-ai-healthcare",
    day: "day1",
    start_time: "13:30",
    end_time: "13:45",
    title: "Behind the Hype: The Real Impact of AI on Health Care and Social Care",
    description: null,
    location: "Main Hall",
    type: "Talk",
    speaker: { name: "Dr. Marian Daryouzeh, EY | Senior Executive | Healthcare and Life sciences, EY" }
  },
  {
    id: "11",
    day: "day1",
    start_time: "13:45",
    end_time: "14:00",
    title: "The Businesses Winning Right Now Aren't Bigger - They're Faster",
    description: null,
    location: "Main Hall",
    type: "Session",
    speaker: { name: "Sug Sahadevan, Director, Thumba Ltd" }
  },
  {
    id: "12",
    day: "day1",
    start_time: "14:00",
    end_time: "14:15",
    title: "Sleeping With One AI Open: The (In)Security of AI Supply Chain",
    description: null,
    location: "Main Hall",
    type: "Session",
    speaker: { name: "Marta Janus, Principal Adversarial ML Researcher, Hidden Layer" }
  },
  {
    id: "from-advisory-to-autonomous",
    day: "day1",
    start_time: "14:15",
    end_time: "14:30",
    title: "From Advisory to Autonomous: Scaling Agentic AI in the Enterprise",
    description: null,
    location: "Main Hall",
    type: "Session",
    speaker: { name: "Artur Skowroński - Head of Application Development, VirtusLab" }
  }
];
